import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { B2CLoginError } from 'Images';

interface ITextNotification {
  isWarning: boolean;
}

export const TextNotification = ({ isWarning }: ITextNotification) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.General
  ).activityGuard;
  const isDesktop = useIsDesktop();

  return (
    <>
      <Avatar
        alt=''
        src={B2CLoginError}
        sx={{
          width: '142px',
          height: '97px',
        }}
      />
      <Stack
        alignItems='center'
        sx={{
          maxWidth: '475px',
          textAlign: 'center',
        }}
      >
        <Typography variant='h5' sx={{ mb: '10px' }}>
          {isWarning ? dictionary.stayLoggedIn : dictionary.reconnectAgain}
        </Typography>
        {isWarning ? (
          <>
            <Typography variant='body2'>
              {dictionary.noticedInactivity}
            </Typography>
            <Typography variant='body2'>
              {dictionary.autoLogoutReasoning}
            </Typography>
          </>
        ) : (
          <>
            <Typography variant='body2'>
              {dictionary.inactivityLogout}
            </Typography>
            <Typography
              variant='body2'
              sx={{
                maxWidth: isDesktop ? '360px' : '200px',
              }}
            >
              {dictionary.reconnectAgainAfterLogout}
            </Typography>
          </>
        )}
      </Stack>
    </>
  );
};
